import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { AuthenticationGuard } from '@quorum/authentication/services';
import { XsrFixedOperationsModule } from '@quorum/xsr-fixed-operations';
import { XsrLabourOperationsModule } from '@quorum/xsr-labour-operations';
import { XsrVehicleModule } from '@quorum/xsr-vehicle';
import { MenuComponent } from './menu/menu.component';
import { QuoteMenuComponent } from './quote-menu/quote-menu.component';
import { XsrMaintenanceMenuNgUiModule } from './xsr-maintenance-menu-ng-ui.module';
import { MenuShellComponent } from './menu-shell/menu-shell.component';

@NgModule({
  imports: [
    XsrMaintenanceMenuNgUiModule,
    XsrLabourOperationsModule,
    XsrVehicleModule,
    XsrFixedOperationsModule,
    MatDialogModule,
    RouterModule.forChild([
      {
        path: 'vehicle/:id',
        data: { shouldReuseRoute: true, key: 'menu' },
        component: MenuShellComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'xs/vehicle/:id',
        component: MenuComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'xs/vehicle/:id/quote/:quoteId',
        component: QuoteMenuComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'hyundai/vehicle/:id',
        data: { shouldReuseRoute: true, key: 'menu' },
        component: MenuShellComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'gm/vehicle/:id',
        data: { shouldReuseRoute: true, key: 'menu' },
        component: MenuShellComponent,
        canActivate: [AuthenticationGuard],
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'menu',
      },
    ]),
  ],
  exports: [XsrMaintenanceMenuNgUiModule],
})
export class XsrMaintenanceMenuNgUiFeatureModule {}
